
















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import $ from "jquery";
import "jquery/dist/jquery";
import "datatables.net-bs5";
import "datatables.net-buttons-bs5";
import "datatables.net-buttons/js/buttons.html5.js";
import { DataTableMixin } from "../shared/mixins/datatable.mixin";
import { mixins } from "vue-class-component";
// import { API_URL } from '../constants';
interface TableHeaderModel {
  name: string;
  prop: string;
  formatter: Function;
}

interface TableActionModel {
  name: string;
  prop: string;
  formatter: Function;
}
@Component
export default class DataTable extends Vue {
  @Prop() private headers!: TableHeaderModel[];
  @Prop() private actions!: TableActionModel[];
  @Prop() private data!: any[];
  @Prop() private tableId!: string;
  @Prop() private limit!: number;
  @Prop() pagination!: any;
  @Prop({ default: true }) private hasActions!: boolean;

  // @Prop() private defaultActions

  dataLimit = 10;

  @Watch("data")
  handler() {
    console.log({
      update: "Table Updated"
    });
    this.initTable();
  }

  // private created() {
  //   this.initTable();
  // }

  handleLimitChange() {
    this.$emit("limitChanged", this.dataLimit);
  }

  triggerPagination(page: number) {
    this.$emit("paginate", page);
  }

  getValue(object: Object, key: string) {
    const keys = key.split(".");
    let prop: any = object;
    keys.forEach(key => {
      prop = prop[key];
    });
    return prop;
  }

  getTdValue(header: TableHeaderModel, item: any) {
    const { prop, formatter } = header;

    if (formatter) {
      return formatter(this.getValue(item, prop));
    }

    return this.getValue(item, prop);
  }

  isSlot(field: any) {
    return field.prop in this.$scopedSlots;
  }

  initTable() {
    // const $: any = jQuery;
    // jQuery.noConflict();
    // // const app: any = window;
    const ff: any = $;
    // console.log({
    //   id: this.tableId,
    // });
    ff(`#${this.tableId}`)
      .DataTable()
      .destroy();
    setTimeout(() => {
      ff(`#${this.tableId}`).DataTable({
        // sDom: "lfrti"
        ...{ searching: false, paging: false, info: false }
      });
      // $(".dataTables_paginate").hide();
    }, 1000);
  }
}
